import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";
import Text from "../../components/Text";
import Button from "../../components/Button";

const points = [
    { icon: "", text: "Sends attendance, fee reminders, and exam alerts in the parent’s language" },
    { icon: "", text: "Dedicated 24×7 IVR line for parents to call and hear updates" },
    { icon: "", text: "Automatic retries to ensure message delivery" },
    { icon: "", text: "Huge cost savings on repeated WhatsApp/SMS campaigns" },
];

const schoolBenefits = [{
    title: "What It Does",
    description: <div className="space-y-3">
        <ul className="list-inside list-disc">
            {points.map((section, index) => (
                <li key={"fqweqwewe" + index}><Text label={section.text} cName="text-gray-700 text-xs leading-relaxed" /></li>
            ))}
        </ul>
        <div className="flex md:flex-col items-center gap-4">
            <Button label='Book Live Demo' type='gradient' />
            <Button label='Claim ₹5 Lakh Free Access' type='outlined' />
        </div>
    </div>,

}, {
    title: "Why It Matters",
    description: "Most schools lose parents’ trust because messages go unread or misunderstood. AUTO CONNECT makes sure every parent understands, every message is delivered, and every relationship grows stronger.",
    footer: <Text label={"Result: 100% message delivery, 10+ languages, 24×7 communication, massive cost savings, happier parents."} cName="text-gray-700 text-xs font-medium leading-relaxed" />
},];


export default function AutoConnect() {

    return (
        <Box
            badge={"inspired by PM modi's bhashini initiative"}
            title={"AI Expert — Multilingual Communication (Auto-Connect)"}
            description={"Speak Every Parent’s Language. Build Every Parent’s Trust."}
            leftBlock={
                <div className='col-span-2 md:col-span-1 text-center'>
                    <Text type="description" cName="mt-4 sm:mt-3 text-xs text-[#4D4D4D] text-pretty font-medium" label={"In india 80% of the population cannot understand, read/write in english but the mode of communication used by schools to update parents is normally sms that too in English,  leading to failure in clear communication and updates the parents receive about their children like exams, marks, fees, attendance, homework etc. "} />
                </div>
            }
            rightBlock={schoolBenefits.map((member, index) => <MarktingCard key={"AutoConnect" + index} member={member} />)}
        />
    );
}